'use es6';

import { Component } from 'react';
import classNames from 'classnames';
import GradeTypeConstants from '../../constants/GradeTypeConstants';

/**
 * Simply wraps the appropriate classes around its children.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default class ResultSection extends Component {
  render() {
    const {
      gradeType,
      children
    } = this.props;
    const classes = classNames('result-section', gradeType === GradeTypeConstants.GREAT && 'result-section-great', gradeType === GradeTypeConstants.GOOD && 'result-section-good', gradeType === GradeTypeConstants.OK && 'result-section-ok', gradeType === GradeTypeConstants.BAD && 'result-section-bad');
    return /*#__PURE__*/_jsx("div", {
      className: classes,
      "data-reagan-selector": "result-section",
      children: children
    });
  }
}